// RefertoContext.js
import React, { createContext, useReducer, useEffect } from "react";
import { defaultStateStoriaClinicaRsa } from "app/views/app/Editor/GestioneOggettiRsa";

export const RefertoContext = createContext();

const initialState = {
    diagnosi: { idReferto: 0, quesito: '', idAnagrafica: 0, idDiagnosiReferto: 0, items: [] },
    terapie: [],
    StoriaClinica: {
        anamnesiPatologica: '', dataInizio: '', dataFine: '', diagnosi: '',
        cronicita: '', cronicitaLabel: '', statoClinico: '', statoClinicoLabel: '', descrizioneStato: ''
    },
    StoriaFamiliare: {
        effectiveTime: "", diagnosisValue: "", diagnosisDisplayName: "", diagnosisId: "0",
        diagnosisAge: "0", deathAge: "0", gradoDiParentela: "MTH", gradoDiParentelaDescrizione: "Madre",
        sesso: "F"
    },
    conclusioni: "",
    informazioniAggiuntive: "",
    complicanze: {
        complicazioni: "",
        dettaglio: [{ effectiveTimeLow: "", effectiveTimeHigh: "", nota: "" }],
    },
    suggerimentiMedico: "",
    contentHtml: '',
    allergie: {
        allergene: '', dataInizio: '', dataFine: '', agente: '', codAgente: '', reazione: '',
        codReazione: '', obiettivita: '', severita: '', stato: '', commento: '', tipoAllergia: 'OINT',
        tipoLabel: 'Intolleranza', severitaLabel: '', statoLabel: ''
    },
    precedentiEsami: [],
    terapiaAttuale: [],
    esameObiettivo: "",
    confrontoEsamiPrec: "",
    storiaClinicaRsa: defaultStateStoriaClinicaRsa,
    quesitoDiagnosticoRsa: { quesito: "", items: [] },
    accertamentiConsigliati: [],
    terapiaFarmacologica: { dataInizioTerapia: "", dataFineTerapia: "", farmaci: [] },
    privacyOscuramento: { tipoDocumento: '', livelloPeservatezza: '' },
    notificaReferto: false,
    updated: 0,
};

function refertoReducer(state, action) {
    switch (action.type) {
        case "UPDATE_FIELD":
            return { ...state, [action.field]: action.payload, updated: state.updated + 1 };
        case "APPEND_TO_LIST":
            return { ...state, [action.field]: [...state[action.field], action.payload], updated: state.updated + 1 };
        case "REPLACE_LIST":
            return { ...state, [action.field]: action.payload, updated: state.updated + 1 };
        case "UPDATE_LIST_ITEM":
            return {
                ...state,
                [action.field]: state[action.field].map((item, index) =>
                    index === action.index ? action.payload : item
                ),
                updated: state.updated + 1
            };
        case "REMOVE_LIST_ITEM":
            return {
                ...state,
                [action.field]: state[action.field].filter((_, index) => index !== action.index),
                updated: state.updated + 1
            };
        case "RESET_UPDATED":
            return { ...state, updated: 0 };
        default:
            return state;
    }
}

export const RefertoProvider = ({ children }) => {
    const [state, dispatch] = useReducer(refertoReducer, initialState);

    return (
        <RefertoContext.Provider value={{ state, dispatch }}>
            {children}
        </RefertoContext.Provider>
    );
};
